export default (params) => ({
  trigger: {
    name: 'active_mailer.read_privacy_policy',
    params: params,
  },
  config: {
    schema: {
      subject_id: {
        type: 'string',
      },
    },
    event: {
      name: 'read_explanation',
      params: {
        sub_feature: 'active_mailer_overlay',
        subject_type: 'label',
      },
    },
  },
});
